const File = {

  /**
   * Create file component
   * @param {Node} node
   * @param {Object} props
   * @return {void}
   */
  create(node, props) {
    this.node = node;
    this.options = props;
    this.input = this.node.querySelector('input');
    this.label = this.node.querySelector('label');

    this.input.addEventListener('change', () => {
      this.checkFiles();
    });
  },

  checkFiles() {
    let fileName = '';

    if (this.input.files && this.input.files.length > 1) {
      fileName = (this.input.getAttribute('data-multiple-caption') || '')
        .replace('##count##', this.input.files.length);
    } else {
      fileName = this.input.value
        .split('\\')
        .pop();
    }

    if (fileName) {
      this.label.querySelector('span').innerHTML = fileName;
    }
  },
};

export default File;
